// PeriodicTable.jsx
import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";

const elements = [
  { symbol: "H", name: "Hydrogen", number: 1, group: 1, period: 1 },
  { symbol: "He", name: "Helium", number: 2, group: 18, period: 1 },
  { symbol: "Li", name: "Lithium", number: 3, group: 1, period: 2 },
  { symbol: "Be", name: "Beryllium", number: 4, group: 2, period: 2 },
  { symbol: "B", name: "Boron", number: 5, group: 13, period: 2 },
  { symbol: "C", name: "Carbon", number: 6, group: 14, period: 2 },
  { symbol: "N", name: "Nitrogen", number: 7, group: 15, period: 2 },
  { symbol: "O", name: "Oxygen", number: 8, group: 16, period: 2 },
  { symbol: "F", name: "Fluorine", number: 9, group: 17, period: 2 },
  { symbol: "Ne", name: "Neon", number: 10, group: 18, period: 2 },
  // Add more elements here
];

const CELL_SIZE = 80;

export default function PeriodicTable() {
  return (
    <Box sx={{ overflowX: "auto", padding: 2 }}>
      <Grid container spacing={1} sx={{ width: CELL_SIZE * 18 }}>
        {[...Array(7)].map((_, periodIndex) => (
          <Grid key={periodIndex} container item spacing={1}>
            {[...Array(18)].map((_, groupIndex) => {
              const element = elements.find(
                (el) =>
                  el.period === periodIndex + 1 && el.group === groupIndex + 1
              );

              return (
                <Grid item key={groupIndex}>
                  <Paper
                    elevation={element ? 3 : 0}
                    sx={{
                      width: CELL_SIZE,
                      height: CELL_SIZE,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: element ? "#e3f2fd" : "transparent",
                      border: element ? "1px solid #ccc" : "none",
                    }}
                  >
                    {element ? (
                      <>
                        <Typography variant="caption">
                          {element.number}
                        </Typography>
                        <Typography variant="h6">{element.symbol}</Typography>
                        <Typography variant="caption">
                          {element.name}
                        </Typography>
                      </>
                    ) : null}
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
